import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NbAuthComponent } from '@nebular/auth';
import { NbSpinnerModule } from '@nebular/theme';
import { LoginComponent } from '../login/login.component';

export const routes: Routes = [
  {
    path: '',
    component: NbAuthComponent,
    children: [
      {
        path: 'login/:client',
        component: LoginComponent,
      },
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    NbSpinnerModule
  ],
  exports: [RouterModule],
})
export class NgxAuthRoutingModule {
}
